export default [
  {
    family: 'Roboto Mono',
    weight: 500,
    style: 'normal',
  },
];
